import { render } from "./PostsByTagPage.vue?vue&type=template&id=1d7b4646&ts=true"
import script from "./PostsByTagPage.vue?vue&type=script&lang=ts"
export * from "./PostsByTagPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__